import { render } from "./EditAgent.vue?vue&type=template&id=2a50db89"
import script from "./EditAgent.vue?vue&type=script&lang=js"
export * from "./EditAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__